import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles.module.scss'

const HelperText = React.forwardRef(({ className, as, ...props }, ref) => {
  // const { controlId } = useContext(FormContext)
  const classes = classNames(className, {
    [styles.helperText]: true,
  })
  let Component = 'span'
  if (as) Component = as

  return (
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    <Component ref={ref} className={classes} {...props} />
  )
})

HelperText.propTypes = {
  /**
   * The HelperText `ref` will be forwarded to the underlying element.
   * Unless the HelperText is rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

HelperText.defaultProps = {
  _ref: null,
}

export default HelperText
